import { useContext } from "react";

import type { KycForms } from "./kycFormContext";
import { KycFormContext } from "./kycFormContext";

/**
 * This functions returns both the KYC business and person react hook form objects as well as the yup validation schemas
 * to be used when submitting each form.
 *
 * This data is set as context within the KycFormProvider component.
 */
export const useKycForms = (): KycForms => {
  const forms = useContext(KycFormContext) as KycForms;
  return forms;
};
